import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.7135 3.33333C6.49059 3.33333 6.28244 3.44473 6.1588 3.6302L5.61711 4.44273C5.24618 4.99913 4.62171 5.33333 3.95301 5.33333H3.33325C2.96506 5.33333 2.66659 5.63181 2.66659 6V12C2.66659 12.3682 2.96506 12.6667 3.33325 12.6667H12.6666C13.0348 12.6667 13.3333 12.3682 13.3333 12V6C13.3333 5.63181 13.0348 5.33333 12.6666 5.33333H12.0468C11.3781 5.33333 10.7537 4.99913 10.3827 4.44273L9.84104 3.6302C9.7174 3.44473 9.50924 3.33333 9.28634 3.33333H6.7135ZM5.0494 2.8906C5.42033 2.3342 6.04479 2 6.7135 2H9.28634C9.95505 2 10.5795 2.3342 10.9504 2.8906L11.4921 3.70313C11.6158 3.8886 11.8239 4 12.0468 4H12.6666C13.7712 4 14.6666 4.89543 14.6666 6V12C14.6666 13.1046 13.7712 14 12.6666 14H3.33325C2.22868 14 1.33325 13.1046 1.33325 12V6C1.33325 4.89543 2.22868 4 3.33325 4H3.95301C4.17591 4 4.38406 3.8886 4.50771 3.70313L5.0494 2.8906ZM7.99992 7.33333C7.26354 7.33333 6.66659 7.93029 6.66659 8.66667C6.66659 9.40305 7.26354 10 7.99992 10C8.7363 10 9.33325 9.40305 9.33325 8.66667C9.33325 7.93029 8.7363 7.33333 7.99992 7.33333ZM5.33325 8.66667C5.33325 7.19391 6.52716 6 7.99992 6C9.47268 6 10.6666 7.19391 10.6666 8.66667C10.6666 10.1394 9.47268 11.3333 7.99992 11.3333C6.52716 11.3333 5.33325 10.1394 5.33325 8.66667Z"
      fill="#282828"
    />
  </svg>
);
export default SVGComponent;
